<template>
  <nav class="header-navbar navbar navbar-with-menu navbar-fixed-top navbar-semi-dark navbar-shadow">
      <div class="navbar-wrapper">
        <div class="navbar-header">
          <ul class="nav navbar-nav">
            <li class="nav-item mobile-menu hidden-md-up float-xs-left">
              <a class="nav-link nav-menu-main menu-toggle hidden-xs">
                <i class="icon-menu5 font-large-1"></i>
              </a>
            </li>
            <li class="nav-item">
              <a class="navbar-brand nav-link">
                <!--<img v-if="$store.state.menuOpened" alt="ME" :src="big_logo" style="max-width: 100%">
                <img v-else alt="ME" :src="small_logo" style="width: 2rem">-->

                <div id="menu_logo" class="brand-logo"></div>
              </a>
            </li>
            <li class="nav-item hidden-md-up float-xs-right">
              <a data-toggle="collapse" data-target="#navbar-mobile" class="nav-link open-navbar-container">
                <i class="icon-ellipsis pe-2x icon-icon-rotate-right-right"></i>
              </a>
            </li>
          </ul>
        </div>
        <div class="navbar-container content container-fluid">
          <div id="navbar-mobile" class="collapse navbar-toggleable-sm">
            <ul class="nav navbar-nav">
              <li class="nav-item hidden-sm-down" @click="$store.state.menuOpened = !$store.state.menuOpened">
                <a class="nav-link nav-menu-main menu-toggle hidden-xs">
                  <i class="icon-menu5"></i>
                </a>
              </li>

              <li class="nav-item dropdown">
                <a class="nav-link menu-toggle" v-if="isValid($store.state.clientName)"><i class="icon-office"></i>{{$store.state.clientName}}</a>
                <a class="nav-link menu-toggle" v-else><i class="icon-office"></i>СП ТОВ Модерн-Експо</a>

              </li>

            </ul>

            <ul class="nav navbar-nav float-xs-right">
              <li class="dropdown dropdown-language nav-item">
                <a id="dropdown-flag" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="dropdown-toggle nav-link">
                
                  <i ref="lang_btn" class="flag-icon" :class="$i18n.tc('lang.logo', $i18n.locale )"></i>
                  <span class="selected-language"> {{$i18n.tc('lang.title', $i18n.locale )}}</span>
                </a>
                
                <div aria-labelledby="dropdown-flag" class="dropdown-menu">
                  <!-- <a class="dropdown-item" :id="lang" v-for="(lang,index) in $i18n.availableLocales" :key="index" @click="changeLanguage(lang)">
                    <i class="flag-icon" :class="$i18n.getLocaleMessage(lang).lang.logo"></i> {{ $i18n.getLocaleMessage(lang).lang.title }}
                  </a> -->
                  <a class="dropdown-item" @click="changeLanguage('ua')"><i class="flag-icon flag-icon-ua"></i> {{ this.$i18n.messages.ua.lang.title }}</a>
                  <a class="dropdown-item" @click="changeLanguage('en')"><i class="flag-icon flag-icon-gb"></i> {{ this.$i18n.messages.en.lang.title }}</a>                  
                  <a class="dropdown-item" @click="changeLanguage('ru')"><i class="flag-icon flag-icon-ru"></i> {{ this.$i18n.messages.ru.lang.title }}</a>
                  <a class="dropdown-item" @click="changeLanguage('pl')"><i class="flag-icon flag-icon-pl"></i> {{ this.$i18n.messages.pl.lang.title }}</a>
                 
                </div>
              </li>
              <li class="dropdown dropdown-notification nav-item"><a href="#" data-toggle="dropdown" class="nav-link nav-link-label"><i class="ficon icon-bell4"></i><span class="tag tag-pill tag-default tag-danger tag-default tag-up">{{coutnOfNewMessages}}</span></a>
                <ul class="dropdown-menu dropdown-menu-media dropdown-menu-right">
                  <li class="dropdown-menu-header">
                    <h6 class="dropdown-header m-0"><span class="grey darken-2">{{$t('titles.user_messages')}}</span><span class="notification-tag tag tag-default tag-danger float-xs-right m-0">{{coutnOfNewMessages}} New</span></h6>
                  </li>
                  <li class="list-group scrollable-container">
                    <a href="javascript:void(0)" class="list-group-item" v-for="(item,index) in newmessage" :key="index">
                      <div class="media">
                        <div class="media-left valign-middle"><i class="icon-check2 icon-bg-circle bg-green bg-accent-3"></i></div>
                        <div class="media-body">
                          <h6 class="media-heading">{{item.title}}</h6>
                          <p class="notification-text font-small-3 text-muted">{{item.body}}</p><small>
                            <time  class="media-meta text-muted">{{item.time}}</time></small>
                        </div>
                      </div></a></li>
                  <li class="dropdown-menu-footer"><a href="javascript:void(0)" class="dropdown-item text-muted text-xs-center">Прочитати всі повідомленн</a></li>
                </ul>
              </li>
              
              <li class="dropdown dropdown-user nav-item">
                <a id="dropdown_usr" data-toggle="dropdown" class="dropdown-toggle nav-link dropdown-user-link">
                  <span class="avatar avatar-online">
                    <img :src="$store.getters.getProfilePhoto"/>
                    <i></i>
                  </span>
                  <span class="user-name">{{ $store.state.userName }}</span>
                </a>
                <div class="dropdown-menu dropdown-menu-right">
                  <router-link :to="{ name: 'profile'}"><a class="dropdown-item"><i class="icon-head"></i> {{ $t('titles.profile')}}</a></router-link>
                  <!-- <router-link :to="{ name: 'tasks'}"><a class="dropdown-item"><i class="icon-clipboard2"></i> {{ $t('titles.tasks')}}</a></router-link> -->
                  <!--<a class="dropdown-item"><i class="icon-calendar5"></i> Calender</a>-->
                  <div class="dropdown-divider"></div>
                  <a class="dropdown-item" @click="LogOut"><i class="icon-power3"></i> {{ $t('titles.logout')}}</a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
  </nav>

</template>
<script>
    export default {
        data(){
            return{               
               coutnOfNewMessages:null,
                name: "",
                //vertical-menu.css
                big_logo: require("../../assets/pictures/me_logo_dark_big.png"),
                small_logo: require("../../assets/pictures//me_logo_small.png"),

            }
        },
        computed:{
            /*isBurgerActive() {
                return this.$store.getters.getNavOpen;
            }*/
            // countOfMessages(){
            //   return this.messages.length;
            // },
            newmessage(){
              let rez = this.$store.state.userMessages;
              rez.length != 0 ? this.coutnOfNewMessages = rez.length : this.coutnOfNewMessages = null
              return rez;
            }

        },
        methods: {
            /*toggle() {
               this.$store.commit('toggleNav')
            }*/
          getFromLocal(key, lang){
            return this.$i18n.tc(key, lang);
          },
          LogOut(){
            this.clearUserInfo();
            this.$router.push({name: 'login'});
          }
        },
        mounted(){
          this.name = localStorage.getItem("name");
          this.clientName = JSON.parse(localStorage.getItem("clientName"));

        }
    }
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/menu/Navbar.vue